import { Checkbox, Drawer, Grid, Menu, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from '@mui/material';
import React, { useContext, useState } from 'react'
import style from "../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import dashboardStyles from './../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';
import checkboxStyles from './../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss'
import globalStyles from "../../../assets/styles/global.module.scss";
import { WhatsappCampaignContext, WhatsappCampaignContextPayload } from '../../../context/whatsappCampaignContext';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { archiveCampaignPayload, createCampaignResponse, pauseCampaignPayload, runCampaignPayload } from '../../../models/axiosModel';
import moment from 'moment';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CampaignAnalysis from './campaignAnalysis';
import GlobalPopUp from '../../utility/globalPopUp';
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup';
import GlobalButton from '../../utility/globalButton/button';
import RetargetDrawer from './retargetDrawer';
import { CAMPAIGN_ACTION_BUTTONS, CAMPAIGN_STATUS, CAMPAIGN_STATUS_MESSAGES, getColorFromStatus } from './campaignConstant';
import CampaignListTable from './campaignListTable';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface campaignTableInterface {
    getCampaignDataApiCall: (campaign_id?: number) => Promise<void>
    getCampaignListApiCall: () => void,
}

type CampaignStatusKey = "draft" | "in progress" | "scheduled" | "paused" | "archived" | "completed";

interface actioBtn {
    actionBtnText: string,
    isActionBtnDisabled: (campaign: createCampaignResponse) => boolean,
    onClickOfActionBtn: (campaign: createCampaignResponse) => void,
} 

interface campaign_status {
    status_name: string,
    flagShowActionBtn: boolean,
    actionBtns: actioBtn[]
}

const CampaignList = (props: campaignTableInterface) => {
    const navigate = useNavigate();
    const { getCampaignDataApiCall, getCampaignListApiCall } = props
    const { whatsappCampaignListdData, deleteCampaignApi, runCampaignApi, resumeCampaignApi, archiveCampaignApi, pauseCampaignApi } = useContext(WhatsappCampaignContext) as WhatsappCampaignContextPayload;
    const { flagLoading, setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { setSelectedWhatsAppCampaign } = useContext(WhatsappCampaignContext) as WhatsappCampaignContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))
    const breakPoints = {
        flagLargeScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
        flagMobileScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 600px)'),
        flagTabletScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 740px)'),
    }

    const getInnerHeightOfPage = () => {
        if(breakPoints.flagTabletScreen){
            if(breakPoints.flagMobileScreen){
                return window.innerHeight - 250;
            } else {
                return window.innerHeight - 290;
            }
        } else {
            return window.innerHeight - 230;
        }
    }

    const innerHeight = getInnerHeightOfPage();

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);
    const [selectedCampaign, setSelectedCampaign] = useState<createCampaignResponse | null>(null);

    // const [activeFilters, setActiveFilters] = useState<string[] | null>(["draft", "in progress", "scheduled" ,"completed"])
    const [activeCampaignFilters, setActiveCampaignFilters] = useState<string[] | null>([CAMPAIGN_STATUS["DRAFT"].toLowerCase(), CAMPAIGN_STATUS["IN_PROGRESS"].toLowerCase(), CAMPAIGN_STATUS["SCHEDULED"].toLowerCase(), CAMPAIGN_STATUS["PAUSED"].toLowerCase(), CAMPAIGN_STATUS["COMPLETED"].toLowerCase()])

    const deletableCampaignStatus = [CAMPAIGN_STATUS["DRAFT"].toLowerCase(), CAMPAIGN_STATUS["SCHEDULED"].toLowerCase()];
    const [openRetargetDrawer, setOpenRetargetDrawer] = useState<boolean>(false);

    const [searchParams] = useSearchParams();
    const campaign_id = searchParams.get('campaign_id');


    const checkDisableDeleteBtn = (campaign: createCampaignResponse) => {
        if (whatsappCampaignListdData && whatsappCampaignListdData.length > 0 && campaign) {
            const currentCampaign = whatsappCampaignListdData.find((list) => list.campaign_id == campaign?.campaign_id);
            if (currentCampaign) {
                if (deletableCampaignStatus?.includes(currentCampaign.campaign_execution_status_name.toLowerCase())) {
                    return false;
                }
            }
        }
        return true;
    }

    const menuItem = [
        // {
        //     label: "Clone Campaign",
        //     action: (e: any) => { },
        // },
        {
            label: "Delete",
            action: (e: createCampaignResponse) => {
                setSelectedCampaign(e);
                setShowDeleteConfirmation(true);
            },
            isDisable: (campaign: createCampaignResponse) => checkDisableDeleteBtn(campaign),
        }
    ]

    const getCampaignStatusObj = (status_name: string, flagShowActionBtn: boolean, actionBtns: actioBtn[]) => {
        return {
            status_name,
            flagShowActionBtn,
            actionBtns,
        }
    }

    const getActionBtnsObj = (actionBtnText: string, onClickOfActionBtn: (campaign: createCampaignResponse) => void, isActionBtnDisabled: (campaign: createCampaignResponse) => boolean = () => false) => {
        return {
            actionBtnText,
            isActionBtnDisabled,
            onClickOfActionBtn,
        };
    }

    const campaignStatus: Record<CampaignStatusKey, campaign_status> = {
        "draft": getCampaignStatusObj(CAMPAIGN_STATUS["DRAFT"], true,
                    [
                        getActionBtnsObj(CAMPAIGN_ACTION_BUTTONS["EXECUTE"] , (campaign: createCampaignResponse) => excuteBtnClick(campaign.campaign_id), (campaign: createCampaignResponse) => !campaign?.whatsapp_template_id),
                        getActionBtnsObj(CAMPAIGN_ACTION_BUTTONS["ARCHIVE"] , (campaign: createCampaignResponse) => archiveCampaign(campaign.campaign_id))
                    ]
                ),
        "in progress": getCampaignStatusObj(CAMPAIGN_STATUS["IN_PROGRESS"], true, 
                        [
                            getActionBtnsObj(CAMPAIGN_ACTION_BUTTONS["PAUSE"], (campaign: createCampaignResponse) => pauseCampaign(campaign.campaign_id)),
                        ]
                    ),
        "scheduled": getCampaignStatusObj(CAMPAIGN_STATUS["SCHEDULED"], true,
                        [
                            getActionBtnsObj(CAMPAIGN_ACTION_BUTTONS["EXECUTE"], (campaign: createCampaignResponse) => excuteBtnClick(campaign.campaign_id)),
                        getActionBtnsObj(CAMPAIGN_ACTION_BUTTONS["ARCHIVE"] , (campaign: createCampaignResponse) => archiveCampaign(campaign.campaign_id))
                        ]
                    ),
        "paused": getCampaignStatusObj(CAMPAIGN_STATUS["PAUSED"], true, 
                    [
                        getActionBtnsObj(CAMPAIGN_ACTION_BUTTONS["RESUME"], (campaign: createCampaignResponse) => resumeCampaign(campaign.campaign_id)),
                        getActionBtnsObj(CAMPAIGN_ACTION_BUTTONS["ARCHIVE"] , (campaign: createCampaignResponse) => archiveCampaign(campaign.campaign_id))
                    ]
                ),
        "completed": getCampaignStatusObj(CAMPAIGN_STATUS["COMPLETED"], true, 
                        [
                            getActionBtnsObj(CAMPAIGN_ACTION_BUTTONS["RETARGET"], (campaign: createCampaignResponse) => {setSelectedCampaign(campaign); setOpenRetargetDrawer(true);}),
                            getActionBtnsObj(CAMPAIGN_ACTION_BUTTONS["ARCHIVE"] , (campaign: createCampaignResponse) => archiveCampaign(campaign.campaign_id))
                        ]
                    ),
        "archived": getCampaignStatusObj(CAMPAIGN_STATUS["ARCHIVED"], false, []),
    };

    const deleteCampaignApiCall = async (campaign_id: number) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true })
        const res = await deleteCampaignApi(campaign_id);
        if (res.status) {
            showSuccess(CAMPAIGN_STATUS_MESSAGES["CAMPAIGN_DELETE"])
            getCampaignDataApiCall();
        } else {
            handleError(res);
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false })
    }

    const handleSortByUpdatedAt = (whatsappCampaignListdData: createCampaignResponse[]) => {
        return [...whatsappCampaignListdData].sort((a, b) => {
            const timestampA = moment(a.updated_at_timestamp ? a.updated_at_timestamp : a.created_at_timestamp).valueOf();
            const timestampB = moment(b.updated_at_timestamp ? b.updated_at_timestamp : b.created_at_timestamp).valueOf();

            if (isNaN(timestampA) || isNaN(timestampB)) return 0;
            if (timestampA === timestampB) {
                const timeA = moment(a.updated_at_timestamp).format('HH:mm:ss');
                const timeB = moment(b.updated_at_timestamp).format('HH:mm:ss');
                return timeB.localeCompare(timeA);
            }
            return timestampB - timestampA;
        });
    };

    const handleCheckBoxData = (fieldName: string) => {
        if (activeCampaignFilters?.includes(fieldName)) {
            setActiveCampaignFilters(activeCampaignFilters.filter((filter: string) => filter != fieldName))
        }
        else {
            if (activeCampaignFilters) {
                setActiveCampaignFilters([...activeCampaignFilters, fieldName])
            }
            else {
                setActiveCampaignFilters([fieldName])
            }
        }
    }

    const handleFilteredCampaignData = (whatsappCampaignListdData: createCampaignResponse[]) => {

        const filteredData = whatsappCampaignListdData.filter((campaign) =>
            activeCampaignFilters?.includes(campaign.campaign_execution_status_name.toLowerCase())
        );

        return handleSortByUpdatedAt(filteredData);
    };

    const excuteBtnClick = async (id: number) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        const payload: runCampaignPayload = {
            campaign_id: id,
        }
        const res = await runCampaignApi(payload);
        if (!(res.status)) {
            handleError(res);
        } else {
            showSuccess(CAMPAIGN_STATUS_MESSAGES["EXECUTE_SUCCESS"])
            getCampaignListApiCall();
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const resumeCampaign = async (campaign_id: number) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        const payload: runCampaignPayload = {
            campaign_id: campaign_id,
        }
        const res = await resumeCampaignApi(payload);
        if (!(res.status)) {
            handleError(res);
        } else {
            showSuccess(CAMPAIGN_STATUS_MESSAGES["RESUME_SUCCESS"])
            getCampaignListApiCall();
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const archiveCampaign = async (campaign_id: number) => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const payload: archiveCampaignPayload = {
            campaign_id: campaign_id
        }

        const res = await archiveCampaignApi(payload);
        if(!(res.status)){
            handleError(res);
        } else {
            showSuccess(CAMPAIGN_STATUS_MESSAGES["ARCHIVE_SUCCESS"])
            getCampaignListApiCall();
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const pauseCampaign = async (campaign_id: number) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        const payload: pauseCampaignPayload = {
            campaign_id: campaign_id,
            pause_reason: "",
        }
        const res = await pauseCampaignApi(payload);
        if (!(res.status)) {
            handleError(res);
        } else {
            showSuccess(CAMPAIGN_STATUS_MESSAGES["PAUSE_SUCCESS"])
            getCampaignListApiCall();
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const renderActionBtnForCampaign = (btnText: string, disabled: boolean, onClick: () => void) => {
        return (
            <Grid item>
                <GlobalButton
                    buttonText={btnText}
                    sx={{ width: "80px", padding: "4px 10px !important", fontSize: "13px !important" }}
                    disabled={disabled}
                    className='primaryButtonStyle'
                    onClick={() => { onClick() }}
                />
            </Grid>
        );
    }

    const actionButtonsForCampaign = (campaign: createCampaignResponse) => {
        const campaign_status = campaign.campaign_execution_status_name.toLowerCase() as CampaignStatusKey; 
        const campaignStatusObj: campaign_status = campaignStatus[campaign_status];

        if(campaignStatusObj?.flagShowActionBtn){
            return campaignStatusObj?.actionBtns?.map((actionBtn) => {
                return renderActionBtnForCampaign(actionBtn?.actionBtnText, actionBtn?.isActionBtnDisabled(campaign), () => actionBtn?.onClickOfActionBtn(campaign))
            })
        } else {
            return "-";
        }
    } 

    const renderCampaignStatusCheckBoxFilter = (status: string) => {
        return (
            <Grid item key={status}>
                <Grid container direction={"row"} gap={breakPoints.flagMobileScreen ? 0.5 : 1} flexWrap={"nowrap"}>
                    <Grid item>
                        <Checkbox
                            className={`${style.checkBoxFilter} ${style.defaultChatbotCheckBox} ${globalStyles.displayInline}`}
                            // disabled={!editIntegrationData ? true : false}
                            checked={activeCampaignFilters?.includes(status?.toLowerCase())}
                            disableRipple
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleCheckBoxData(status?.toLowerCase())}
                        />
                    </Grid>
                    <Grid item mt={breakPoints.flagMobileScreen ? "0px" : "1px"}>
                        <span className={`${checkboxStyles.audioFieldLabel} ${checkboxStyles.darkFontWeightField}`}>{status}</span>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    return (
        <>
            {campaign_id ?
                <Grid item xs={12} sm={12} className={`${style.tableGridItem} ${globalStyles.fullwidth}`}>
                    <CampaignAnalysis getCampaignDataApiCall={getCampaignDataApiCall} />
                </Grid>
                :
                <Grid item xs={12} sm={12} className={style.tableGridItem}>
                    <Grid container direction={"column"} gap={"12px"}>
                        <Grid item mt={{ lg: 1 }}>
                            <Grid container direction={"row"} gap={"20px"}>
                                {Object.values(campaignStatus).map((status: campaign_status) => {
                                    return renderCampaignStatusCheckBoxFilter(status?.status_name)
                                })}
                            </Grid>
                        </Grid>

                        <Grid item className={globalStyles.fullwidth}>
                            <CampaignListTable
                                campaignList={whatsappCampaignListdData ? handleFilteredCampaignData(whatsappCampaignListdData) : null}
                                tableInnerHeight={innerHeight}
                                actionButtonsForCampaign={actionButtonsForCampaign}
                                menuItem={menuItem}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            }

            <Drawer
                anchor={"right"}
                open={openRetargetDrawer}
                onClose={() => { setOpenRetargetDrawer(false); setSelectedCampaign(null) }}
                variant="temporary"
                ModalProps={{
                    disableEnforceFocus: true,
                    keepMounted: false,
                }}
                PaperProps={{
                    className: `${style.retargetDrawerPaper} ${breakPoints.flagLargeScreen ? style.retargetDrawerPaperLargeScreen : style.retargetDrawerPaperSmallScreen}`,
                }}
                BackdropProps={{
                    className: style.retargetDrawerBackdrop,
                }}
            >
                <RetargetDrawer
                    selectedCampaign={selectedCampaign as createCampaignResponse}
                    setOpenRetargetDrawer={setOpenRetargetDrawer}
                />
            </Drawer>

            {
                showDeleteConfirmation &&
                <GlobalPopUp
                    open={showDeleteConfirmation}
                    handleClose={() => { setShowDeleteConfirmation(false) }}
                >
                    <GlobalDeletePopup
                        deleteDescription={`Are you sure you want to delete ${selectedCampaign?.campaign_title}`}
                        onClose={() => { setShowDeleteConfirmation(false) }}
                        onDelete={() => {
                            if (selectedCampaign) {
                                deleteCampaignApiCall(selectedCampaign.campaign_id);
                            }
                            setShowDeleteConfirmation(false)
                        }}
                    />
                </GlobalPopUp>
            }
        </>
    )
}

export default CampaignList;
